<template>
	<div>
		<button type="button" class="btn btn-sm btn-primary" @click="toggleLegendContainer">Layers</button>
	</div>
</template>

<script>
import toolbar_mix from '../mixins/toolbar/toolbar-container.js';
export default {

  name: 'layers-toggle',
  mixins: [toolbar_mix],
  methods: {
    toggleLegendContainer(){
      this.$legendContainer.showLegend = !this.$legendContainer.showLegend
    }
  },
  data () {
    return {

    }
  },
  created () {
  	this.$parent.$emit('tool-created', this);
    Object.defineProperties(this, {        
        $legendContainer: {
          enumerable: true,
          get: () => this.$parent.$legendContainer,
        },
        $map: {
          enumerable: true,
          get: () => this.$parent.$map,
        },
      })
  },
  mounted () {
    this.legendInit().then(() => {
      // console.log("Mounting layers toggle")
      // console.log(this.$legendContainer)
    })
  }
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// resources/js/map/MapComponents/Toolbar/LayersToggle.vue